export enum WoundOdorEnum {
  None = 1,
  Slight = 2,
  Moderate = 3,
  Strong = 4
}

export const WoundOdorOptions = [
{ id: 1, label: 'None' },
{ id: 2, label: 'Slight' },
{ id: 3, label: 'Moderate' },
{ id: 4, label: 'Strong' }
];
